import Box from "@/components/Box";
import CloseButton from "@/components/CloseButton";
import { SnpAccordionRow } from "@/components/reports/InterpretationSharedRows";
import { MODAL_Z_INDEX } from "@/core/constants";
import Accordion from "@/tpo/Accordion";
import Stack from "@/tpo/Stack";
import { theme } from "@/core/theme";
import getSnpColor, { getSnpImpactSymbol } from "@/utils/getSnpColor";

export function mapFamilySnpsToRows(familyData) {
  if (!familyData?.snps) return [];

  return familyData.snps.map(snp => ({
    title: snp.name,
    accentColor: getSnpColor(snp.value),
    badgeText: snp.alleles?.length ? snp.alleles.join("") : "--",
    interpretation: snp.interpretation,
    suggestion: snp.suggestion,
    symbol: getSnpImpactSymbol(snp.value, snp.impact_activity ?? snp.impactActivity)
  }));
}

export default function SnpFamilyModal({ familyName, familyData, onClose }) {
  if (!familyName) return null;

  const rows = mapFamilySnpsToRows(familyData);
  const firstRowValue =
    rows.length > 0 ? `snp-row-${rows[0].badgeText}-${rows[0].title}` : undefined;

  return (
    <Box
      position="absolute"
      top={0}
      right={0}
      bottom={0}
      left={0}
      zIndex={MODAL_Z_INDEX + 2}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={20}
      overflow="hidden"
      onClick={onClose}
    >
      <Box position="absolute" top={0} right={0} bottom={0} left={0} bg="black" opacity={0.25} />
      <Box
        position="relative"
        zIndex={1}
        maxWidth={713}
        width="100%"
        maxHeight="100%"
        minHeight={0}
        bg="white"
        borderRadius={20}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        onClick={e => e.stopPropagation()}
      >
        <Box display="flex" alignItems="center" p={20} flexShrink={0}>
          <Box fontFamily="gilroyBold" fontSize={24}>
            {familyName}
          </Box>
          <Box ml="auto">
            <CloseButton
              height={40}
              width={40}
              color={theme.colors.dark}
              onClick={onClose}
              bg="white"
              data-component-name="SnpFamilyModalCloseButton"
            />
          </Box>
        </Box>
        <Stack gap={0} overflow="auto" flex="1" minHeight={0}>
          <Accordion size={0} key={familyName} defaultValue={firstRowValue}>
            {rows.map((row, idx) => (
              <SnpAccordionRow key={`${row.title}-${row.badgeText}-${idx}`} row={row} />
            ))}
          </Accordion>
        </Stack>
      </Box>
    </Box>
  );
}
